import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap";
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

const UnassignedLeads = (props) => {
  const { user, role, setCurrentLead, setIsAddForm, filterObj, leadType } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [moderator, setModerators] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  // console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      getLeads();
    }
  }, [user, filterObj, leadType]);

  useEffect(() => {
    setColumns([
      {
        name: 'Lead Name',
        selector: row => row.name,
      },
      {
        name: 'Client Name',
        selector: row => row.clientName,
      },
      {
        name: 'Description',
        cell: (row) => <>
          <span title={row?.intro}>{row.intro.length > 30 ? row.intro.substring(0, 30) + '...' : row.intro}</span>
        </>,
      },
      {
        name: 'Project',
        selector: row => row.project?.length > 0 ? row.project[0]?.name : ' - ',
      },
      user?.role == 'Admin' && leadType == 'moderator' &&
      {
        cell: (row) => <>
          <AvForm style={{ textAlign: 'left' }}>
            <AvField onChange={(e) => assignToModerator(row, e.target.value)} style={{ minWidth: 100, padding: 5, paddingLeft: 8, paddingRight: 8 }}
              type="select"
              name="assignToM"
              value={row?.assignToM ? row?.assignToM : ""}
              placeholder={"Select Moderator"}
            >
              <option value="">Select Moderator</option>
              {moderator.map((item) => {
                return <option key={item?._id} value={item?._id}>{item.name}</option>
              })}
            </AvField>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Assign To Moderator',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      ['Admin', 'Moderator'].includes(user?.role) &&
      {
        cell: (row) => <>
          <AvForm style={{ textAlign: 'left' }}>
            <AvField onChange={(e) => assignToDealer(row, e.target.value)} style={{ minWidth: 100, padding: 5, paddingLeft: 8, paddingRight: 8 }}
              type="select"
              name="assignToD"
              value={row?.assignToD ? row?.assignToD : ""}
              placeholder={"Select Channel Partner"}
            >
              <option value="">Select Channel Partner</option>
              {dealers.map((item) => {
                if (row?.project[0]?.dealers?.length > 0) {
                  if ((row?.project[0]?.dealers.findIndex(x => x == item?._id)) != -1)
                    return <option key={item?._id} value={item?._id}>{item.name}</option>
                }
              })}
            </AvField>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Assign To Channerl Partner',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      ['Admin', 'Moderator'].includes(user?.role) &&
      {
        cell: (row) => <>
          {row?.status == 'Open' &&
            <span style={{ backgroundColor: 'blue', color:'white', fontWeight: 'bold', border: '1px dotted blue', padding: 4, borderRadius: 5 }}>{row?.status}</span>
          }
          {row?.status == 'In Process' &&
            <span style={{ backgroundColor:'orange', color: 'white', fontWeight: 'bold', border: '1px dotted orange', padding: 4, borderRadius: 5 }}>{row?.status}</span>
          }
          {row?.status == 'Closed' &&
            <span style={{ backgroundColor:'green', color: 'white',  fontWeight: 'bold', border: '1px dotted green', padding: 4, borderRadius: 5 }}>{row?.status}</span>
          }
          {row?.status == 'Rejected' &&
            <span style={{ backgroundColor:'red', color: 'white', fontWeight: 'bold', border: '1px dotted red', padding: 4, borderRadius: 5 }}>{row?.status}</span>
          }
          {row?.status == 'Archived' &&
            <span style={{ backgroundColor:'black', color: 'white', fontWeight: 'bold', border: '1px dotted black', padding: 4, borderRadius: 5 }}>{row?.status}</span>
          }
        </>,
        name: 'Status',
        selector: row => row.status,
      },
      user?.role == 'Dealer' &&
      {
        cell: (row) => <>
          <AvForm style={{}}>
            <div style={{ position: 'absolute', left: 35 }}>
              <AvField onChange={(e) => handleUpdateStatus(row, e.target.value)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="status"
                placeholder={"Select Status"}
                value={row?.status}
              >
                <option value="">Select Status</option>
                <option value={"Open"}>Open</option>
                <option value={"In Process"}>In Process</option>
                <option value={"Rejected"}>Rejected</option>
                <option value={"Closed"}>Closed</option>
              </AvField>
            </div>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Status',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => props?.history.push("/lead/" + row?._id)}
            title={"View"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {user?.role == 'Admin' &&
            <Button onClick={() => { if (row?.status == 'Archived') handleUnarchivedLead(row); else handleArchivedLead(row) }}
              title={row?.status == 'Archived' ? "Unarchive" : "Archive"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className={`mdi ${row?.status == 'Archived' ? 'mdi-archive-arrow-up' : 'mdi-archive-arrow-down'}`} style={{ fontSize: 20 }}></span></Button>
          }
          {user?.role == 'Admin' || row?.addedBy == user?._id ?
            <Button onClick={() => handleUpdateLead(row)}
              title={"Edit"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
            : null
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [moderator, dealers, leadType]);

  const getLeads = async () => {
    await getModerators();
    post("/lead/list", { companyId: user?.companyId, filterObj: filterObj, type: leadType, token: user?.token })
      .then(json => {
        // console.log('response from get lead list', json);
        setData(json?.data);
        if (!filterObj) {
          let clients = [];
          json?.data?.map((item) => {
            const found = clients.findIndex(x => x.name == item?.clientName);
            if (found == -1) {
              clients.push({ name: item?.clientName, id: item?.clientName });
            }
          });
          props?.setClients(clients);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getLeadsByModer = async () => {
    await getDealers();
    post("/lead/list", { token: user?.token, filterObj: filterObj, type: 'moderator', companyId: user?.companyId })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getModerators = () => {
    get("/moderator/list?companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get user list', json);
        if (json.statusCode == 200) {
          setModerators(json?.data);
          getDealers();
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getDealers = () => {
    get("/dealer/list?companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        console.log('response from get dealer list', json);
        if (json.statusCode == 200) {
          setDealers(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const assignToModerator = (lead, moderatorId) => {
    let moder = moderator.find(x => x._id == moderatorId);
    setModalData({ type: "Assign", lead: lead, userName: moder.name, userId: moderatorId });
    setIsModal(true);
  }

  const assignToDealer = (lead, dealerId) => {
    let dealer = dealers.find(x => x._id == dealerId);
    setModalData({ type: "Assign", to: 'dealer', lead: lead, userName: dealer.name, userId: dealerId });
    setIsModal(true);
  }

  const handleArchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Archive", lead: lead });
    setIsModal(true);
  }

  const handleUnarchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Unarchive", lead: lead });
    setIsModal(true);
  }

  const handleUpdateStatus = (lead, status) => {
    console.log('updating lead', lead);
    setModalData({ type: "Status", lead: lead, status: status });
    setIsModal(true);
  }

  const handleUpdateLead = (item) => {
    setCurrentLead(item);
    setIsAddForm(true);
  }

  const onConfirm = () => {
    let body = {};
    if (modalData?.type == 'Assign') {
      if (user?.role == "Admin")
        if (modalData?.to == 'dealer') {
          console.log('lead id', modalData?.lead?._id);
          console.log('timeline', modalData?.lead?.timeline);
          console.log('userName', modalData?.userName);
          console.log('user id', modalData?.userId);
          body = { lead_id: modalData?.lead?._id, status: 'In Process', timeline: { title: 'Assign To Channel Partner', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }, assignToD: modalData?.userId, token: user?.token };
          console.log('assigning to dealer', body);
        } else
          body = { lead_id: modalData?.lead?._id, timeline: { title: 'Assign To Moderator', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }, assignToM: modalData?.userId, token: user?.token };
      else
        body = { lead_id: modalData?.lead?._id, status: 'In Process', timeline: { title: 'Assign To Channel Partner', desc: `Lead Assign to ${modalData?.userName} by ${user?.name}` }, assignToD: modalData?.userId, token: user?.token };
    } else if (modalData?.type == 'Archive') {
      body = { lead_id: modalData?.lead?._id, timeline: { title: 'Archived', desc: `Lead Archived by ${user?.name}.` }, status: 'Archived', token: user?.token };
    } else if (modalData?.type == 'Unarchive') {
      body = { lead_id: modalData?.lead?._id, assignToM: null, assignToD: null, timeline: { title: 'Unarchived', desc: `Lead Unarchived by ${user?.name}.` }, status: 'Open', token: user?.token };
    } else if (modalData?.type == 'Status') {
      body = {
        lead_id: modalData?.lead?._id,
        timeline: { title: 'Status Changed', desc: `Lead status change to ${modalData?.status} by ${user?.name}` },
        status: modalData?.status, token: user?.token
      };
    }
    put("/lead/update", body)
      .then(json => {
        console.log('response from update Lead', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
          props?.setReload(!props?.reload);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => setIsModal(false)}
          data={modalData}
        />
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={{
            headCells: {
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: 15,
                maxWidth: 80
              },
            },
            cells: {
              style: {
                maxWidth: 50
              }
            }
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default UnassignedLeads;
